var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "step0 main_container" },
      [
        _c("h3", { staticClass: "main_title hidden-sm-and-down" }, [
          _vm._v("进入管道")
        ]),
        _c("p", { staticClass: "main_description hidden-sm-and-down" }, [
          _vm._v("请选择您进入官网的管道")
        ]),
        _c("h3", { staticClass: "main_title hidden-md-and-up" }, [
          _vm._v("问题回报")
        ]),
        _vm._t("default"),
        _c("hr", { staticClass: "mt-8" }),
        _c("div", { staticClass: "enter_group" }, [
          _c("h3", { staticClass: "enter_title hidden-md-and-up" }, [
            _vm._v("进入管道")
          ]),
          _c("p", { staticClass: "enter_description hidden-md-and-up" }, [
            _vm._v("请选择您进入星盘的管道")
          ]),
          _c(
            "div",
            {
              staticClass: "enter_item",
              on: {
                click: function($event) {
                  return _vm.next("Line內建瀏覽器")
                }
              }
            },
            [_vm._m(0), _vm._m(1)]
          ),
          _c(
            "div",
            {
              staticClass: "enter_item",
              on: {
                click: function($event) {
                  return _vm.next("一般web瀏覽器")
                }
              }
            },
            [_vm._m(2), _vm._m(3)]
          )
        ])
      ],
      2
    ),
    _c("p", { staticClass: "notice" }, [
      _vm._v(
        "\n    为了保护您的权益，您所填写的资料仅在必要时提供 ASTRORG 星学会展示网站工程团队使用。\n  "
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "enter_logo" }, [
      _c("img", {
        attrs: { src: require("../../assets/report/icon_line.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "enter_content" }, [
      _c("p", { staticClass: "enter_title" }, [_vm._v("Line")]),
      _c("p", { staticClass: "enter_description" }, [
        _vm._v("从LINE选单进入星盘官网")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "enter_logo" }, [
      _c("img", { attrs: { src: require("../../assets/report/icon_web.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "enter_content" }, [
      _c("p", { staticClass: "enter_title" }, [_vm._v("一般浏览器")]),
      _c("p", { staticClass: "enter_description" }, [
        _vm._v("从一般浏览器进入星盘官网")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }